export default function LogSuspense({ area }: { area?: string }) {
  if (area) console.log("LogSuspense: ", area);
  return <></>;
}
